"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function textToListIndex(value, textIndex) {
  var offset = 0;

  for (var i = 0; i < value.length; i++) {
    var ch = value[i];

    if (textIndex === offset && ch.type == null) {
      return i;
    } else if (ch.type == null) {
      offset++;
    }
  }

  return offset;
}

exports.default = textToListIndex;